import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card ,Table} from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { getAllProduct } from "../product/productAction";
import { getAllServiceType } from "../serviceType/serviceTypeAction";
import { getAllTourType } from "../tourTypes/TourTypeAction";
import { getAllMainSubProduct } from "../subproduct/subproductAction";
import { useParams, useNavigate } from 'react-router-dom';
import { productcommissionModification, getSingleProductCommission } from "./commissionAction";
import RemarkModel from './RemarkModal';
import Swal from 'sweetalert2';
import { FaEye, FaArrowLeft,FaArrowAltCircleRight, FaTrash, FaPlus} from 'react-icons/fa';


const CommissionView = () => {
  const dispatch = useDispatch();
  const { name } = useParams();
  const { name1 } = useParams();
  const { name2 } = useParams();
  const { idd } = useParams();
  const navigate = useNavigate();

  const [product, setProduct] = useState("");
  const [productid,setProductid]= useState('');
  const [tourtypeid,setTourtypeid]= useState('');
  const [servicetypeid,setServicetypeid]= useState('');
  const { products } = useSelector((state) => state.productList);
  const { serviceType } = useSelector((state) => state.serviceTypiesList);
  const { tourType } = useSelector((state) => state.tourTypesList);
  const { subproducts2 } = useSelector((state) => state.subproductList);

  const [subproducts22, setSubproducts22] = useState([]);
  const [commissiondata, setCommissionData] = useState({
    id:"",
    commission:"",
    commission_type:"",
    serviceTypeId:"",
    product_id:"",
    status:"",
  });


  const [commissiondata2, setCommissionData2] = useState([]);
  const [allCommission, setAllCommission] = useState("");
  const [applyToAll, setApplyToAll] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const productcommissionData = useSelector((state) => state.productcommissionList);



  const handleOpenRemarkModel = (index) => {
    setSelectedRowIndex(index);
    setOpen(true);
  };
  const handleCloseRemarkModel = () => {
   
    setOpen(false);
    console.log("open",open)
    setSelectedRowIndex(null);
  };
  
  const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadProductCommission(idd);
      return;
    }
  });

  useEffect(() => { 
   
    loadProductCommission(idd);
    setCommissionData({
        id: "",
        commission: "",
        commissiontype: "",
        product_id: "",
        remarks: "",
        serviceTypeId: "",
        status: "",
        subproduct_name : ""
    })
   
  }, []);



     const { register, handleSubmit, formState: { errors } } = useForm();

   

     function loadProductCommission(idd) {
      dispatch(getSingleProductCommission(idd));
    
      const commissionDataArray = cData.map((data) => ({
        id: data.id,
        commission: data.commission,
        commissiontype: data.commission_type,
        product_id: data.product_id,
        remarks:data.remarks,
        serviceTypeId: data.service_type_id,
        status: data.status,
        subproduct_name : data.subproduct_name
      }));
    
      setCommissionData(commissionDataArray);
    }
    
    


  
   const cData = JSON.parse(JSON.stringify(productcommissionData.commissions));
    console.log("cData",cData)
  //  const handleOnChange = e => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   // console.log('name '+name); 
  //   //console.log('value '+value); 
  //   setCommissionData({ ...commissiondata, [name]: value });
  //   /* setRole(prevState => ({
  //     role:{
  //       ...prevState.role,
  //       [name]: value
  //     }
  //   })); */
  // };



  const handleOnChange = (index, e) => {
    const name = e.target.name;
    const value = e.target.value;
  
    // Update the specific item in the commissiondata array
    const updatedCommissionData = commissiondata.map((item, idx) => {
      if (idx === index) {
        return { ...item, [name]: value };
      }
      return item;
    });
  
    setCommissionData(updatedCommissionData);
  };
  
  


  useEffect(() => {
    dispatch(getAllProduct());
    dispatch(getAllServiceType());
    dispatch(getAllMainSubProduct());
    
  }, []);

 
  const handleApplyToAllChange = (event) => {
    const checked = event.target.checked;
    const newSubproducts = commissiondata.map((subproduct) => ({
      ...subproduct,
      commission: checked ? allCommission : subproduct.commission,
    }));
    setCommissionData(newSubproducts);
    setApplyToAll(checked);
  };
  const onBack = () => {
   
    //console.log('select role '+id);
    navigate("/" + name1 + "/" +name2); 
 }


  const handleSubproductCommissionChange = (index, newCommission) => {
    const newSubproducts = [...commissiondata];
    newSubproducts[index].commission = newCommission;
    
    setCommissionData(newSubproducts);
    setApplyToAll(false);
  };
  console.log("commissiondata:", commissiondata);
  console.log("productcommissionData:", productcommissionData);



  const handleOnSubmit = (event) => {
    event.preventDefault();
    // Save the commission data to the database

    const { id, commission, commissiontype,serviceTypeId,status,product_id
    } = commissiondata;

    const commissionUpdation1 = {
      id, commission, commissiontype,serviceTypeId,status,product_id
    };
    dispatch(productcommissionModification(commissionUpdation1));
    Swal.fire({
      title: 'Updated!',
      text: 'Commission Updated Successfully',
      icon: 'success',
      confirmButtonText: 'Okay'
    })
  
    

    
  };

  return (
    <div className="my-4  container-xl">
    <div className="card" style={{marginTop:'-80px'}}>
        <div className="card-header">
            <h3 className="d-flex text-dark text-left mt-2 mb-2"  style={{fontFamily:'Times New Roman' }}>View Commission Details</h3>
        </div>
        <div className="card-body">
            <Row>
                <div><span className="badge bg-success" onClick={onBack} style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></div> 

            </Row>
            <br />
        
        <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}> {/* handleOnSubmit() */}

          <Row className="mb-3">
          
           
            
       
    <div>
         <br />
            <br />
           
          <Table striped bordered hover>
        <thead>
          <tr>
            <th>Sub Product Name</th>
            <th>Commission Type</th>
            <th>Commission Amount</th>
          </tr>
        </thead>

        <tbody>
        {commissiondata && commissiondata.length > 0 ? (
  commissiondata.map((subproduct, index) => (
    <tr key={index}>
      <td>{subproduct.subproduct_name}</td>
      <td>
        <Form.Group as={Col} controlId="formGridStatus">
          <Form.Select
            required
            disabled
            name="status"
            value={subproduct.commissiontype}
            onChange={(e) => handleOnChange(index, e)}
          >
            <option value="">Choose..</option>
            <option
              value="Percentage"
              selected={subproduct.commissiontype === "Percentage" ? true : false}
            >
              Percentage
            </option>
            <option
              value="Fixed"
              selected={subproduct.commissiontype === "Fixed" ? true : false}
            >
              Fixed
            </option>
          </Form.Select>
        </Form.Group>
      </td>
      <td>
        <input
          type="number"
          name="commission"
          min="0"
          max="100"
          disabled
          style={{ width: "220px" }}
          value={subproduct.commission ? subproduct.commission : ""}
          autoComplete="off"
          placeholder="Enter The Commission"
          {...register("commission", { required: true, maxLength: 10 })}
          onChange={(e) => handleOnChange(index, e)}
        />
      </td>
      <td>{subproduct.status == "Approved" ? <><span className="badge bg-success">{subproduct.status}</span></> : subproduct.status == "Rejected" ? <><span className="badge bg-danger" style={{cursor:"pointer"}} onClick={() => handleOpenRemarkModel(index)}>{subproduct.status}</span></>:<><span className="badge bg-primary">{subproduct.status}</span></>}</td>
      {selectedRowIndex === index && ( // Render RemarkModel only for the selected rowIndex
      <RemarkModel cdata={subproduct} cid={subproduct.id} open={open} handleClose={handleCloseRemarkModel} />
    )}
    </tr>
  ))
) : (
  cData.map((subproduct2, index) => (
    <tr key={index}>
      <td>{subproduct2.subproduct_name}</td>
      <td>
        <Form.Group as={Col} controlId="formGridStatus">
          <Form.Select
            required
            disabled
            name="status"
            value={subproduct2.commissiontype}
            onChange={(e) => handleOnChange(index, e)}
          >
            <option value="">Choose..</option>
            <option
              value="Percentage"
              selected={subproduct2.commission_type === "Percentage" ? true : false}
            >
              Percentage
            </option>
            <option
              value="Fixed"
              selected={subproduct2.commission_type === "Fixed" ? true : false}
            >
              Fixed
            </option>
          </Form.Select>
        </Form.Group>
      </td>
      <td>
        <input
          type="number"
          name="commission"
          min="0"
          max="100"
          disabled
          style={{ width: "220px" }}
          value={commissiondata?.commission ? commissiondata?.commission :subproduct2.commission}
          autoComplete="off"
          placeholder="Enter The Commission"
          {...register("commission", { required: true, maxLength: 10 })}
          onChange={(e) => handleOnChange(index, e)}
        />
      </td>
      <td>{subproduct2.status == "Approved" ? <><span className="badge bg-success">{subproduct2.status}</span></> : subproduct2.status == "Rejected" ? <><span className="badge bg-danger" style={{cursor:"pointer"}} onClick={() => handleOpenRemarkModel(index)}>{subproduct2.status}</span></>:<><span className="badge bg-primary">{subproduct2.status}</span></>}</td>
      {selectedRowIndex === index && ( // Render RemarkModel only for the selected rowIndex
      <RemarkModel cdata={subproduct2} cid={subproduct2.id} open={open}  handleClose={handleCloseRemarkModel}  />
    )}
    </tr>
  ))
)}



</tbody>

      </Table>
    </div>
  
          </Row>
          <div class="d-grid  col-2 mx-auto">
         
          </div>

        </Form>
      </div>
      </div>
      </div>
  );
};

export default CommissionView;
